/**
 * The governor's list of open sandboxes (LO-198): words for what `GET /sandboxes`
 * answers. The figures, the cap and every sentence about what they do not prove
 * are the kernel's; this only orders and phrases them.
 */

export const money = (n) => `$${Number(n || 0).toFixed(2)}`;

export function daysWord(n) {
  const d = Math.max(0, Math.floor(Number(n) || 0));
  if (d === 0) return "under a day";
  return `${d} day${d === 1 ? "" : "s"}`;
}

const WHAT = { draft: "draft saved", qa_run: "QA run", read: "opened by its author" };

/** Oldest first: the one most likely to have been forgotten is at the top. */
export function rowsOf(body) {
  return [...(body?.sandboxes || [])]
    .sort((a, b) => String(a.opened_at || "").localeCompare(String(b.opened_at || "")))
    .map((s) => ({
      id: s.request_id,
      app: s.app_type,
      state: s.state === "draft" ? "Draft" : s.state === "pending" ? "Waiting for approval" : s.state,
      author: String(s.requested_by || "").replace(/^user:/, "") || "unknown",
      age: daysWord(s.age_days),
      cost: s.estimate ? `${money(s.estimate.monthly_usd)} a month (estimate)` : "no estimate",
      costTitle: s.estimate?.basis || "",
      quiet: s.idle_days == null ? "" : `${daysWord(s.idle_days)} since ${WHAT[s.last_activity] || "activity"}`,
      canCancel: Boolean(s.can_cancel),
      cancelPath: s.cancel?.path || `/manifest-requests/${s.request_id}/cancel`,
    }));
}

/** "3 open of a cap of 5", and whether a new one would be refused. */
export function capLine(body) {
  if (!body) return { text: "", full: false };
  const open = Number(body.open) || 0;
  const cap = Number(body.cap) || 0;
  return {
    text: `${open} open of a cap of ${cap}`,
    full: cap > 0 && open >= cap,
  };
}

/** The account's shared cost, said apart from the per-sandbox figures. */
export function sharedLine(body) {
  const s = body?.shared;
  if (!s) return "";
  return `${s.label}: ${money(s.monthly_usd)} a month (estimate), ${s.basis}.`;
}
